import { Warehouse, Flame, ShieldCheck, Percent } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { IMG_TRUCK_DELIVERY } from "@/data/site";

const CARDS = [
  {
    icon: Flame,
    title: "Oven Kiln-Dried Presisi",
    text: "Kadar air terkontrol < 12% sehingga kayu tidak menyusut, melengkung, atau pecah setelah terpasang.",
  },
  {
    icon: ShieldCheck,
    title: "Garansi Bebas Lapuk & Rayap",
    text: "Perlakuan anti hama menyeluruh. Kayu rusak karena rayap dalam masa garansi kami ganti.",
  },
  {
    icon: Percent,
    title: "Harga Grosir Distributor",
    text: "Tanpa perantara — harga triplek 18mm murah dan kayu solid langsung dari gudang pabrik.",
  },
];

export const Advantages = () => (
  <section id="keunggulan" data-testid="advantages-section" className="surface py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <SectionHead
        overline="Keunggulan Kami"
        title={<>Mengapa Kontraktor Memilih <span className="italic accent-text">Sinar Al Mubarokah</span></>}
        sub="Standar pabrik, harga distributor, dan layanan yang membuat proyek Anda berjalan tanpa hambatan material."
      />
      <div className="grid gap-6 lg:grid-cols-3">
        <Reveal className="lg:row-span-2">
          <div
            className="group relative h-full min-h-[420px] overflow-hidden rounded-[1.8rem]"
            data-testid="advantage-card-stock"
          >
            <img
              src={IMG_TRUCK_DELIVERY}
              alt="Armada pengiriman PT. SINAR AL MUBAROKAH mengangkut triplek siap kirim"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div
              className="absolute inset-0"
              style={{ background: "linear-gradient(to top, color-mix(in srgb, var(--t-dark) 92%, transparent) 15%, transparent 70%)" }}
            />
            <div className="absolute bottom-0 p-8">
              <span
                className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl"
                style={{ backgroundColor: "var(--t-accent)", color: "var(--t-dark)" }}
              >
                <Warehouse size={22} />
              </span>
              <h3 className="font-serif text-2xl font-semibold text-white">Stok Melimpah, Siap Kirim</h3>
              <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/75">
                Ribuan meter kubik kayu dan triplek tersedia di gudang kami. Order hari ini,
                armada kami berangkat besok — ke seluruh Indonesia.
              </p>
            </div>
          </div>
        </Reveal>
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={0.1 + i * 0.08} className="lg:col-span-1">
            <div
              className="card-surface group h-full rounded-[1.8rem] p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl"
              data-testid={`advantage-card-${i + 1}`}
            >
              <span
                className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl transition-transform duration-500 group-hover:rotate-6"
                style={{ backgroundColor: "color-mix(in srgb, var(--t-accent) 15%, transparent)", color: "var(--t-accent)" }}
              >
                <c.icon size={22} />
              </span>
              <h3 className="font-serif text-xl font-semibold text-brand-ink sm:text-2xl">{c.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-brand-muted">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
